import {useCallback, useMemo} from 'react';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';
import {FLOW_NAMES} from '@/lib/analytics/analyticsConstants';

export interface RecruitmentSearchDetailEventParams {
  recruitment_search_id: string;
  recruitment_screen_name: string;
  search_detail_id: string;
  search_detail_name: string;
  search_detail_value: string;
  campaign_id?: string;
}

function useTrackRecruitmentSearchDetail() {
  const detail = useCallback(
    ({
      recruitment_search_id,
      recruitment_screen_name,
      search_detail_id,
      search_detail_name,
      search_detail_value,
      campaign_id = '',
    }: RecruitmentSearchDetailEventParams) => {
      const recruitmentSearchFlow = AnalyticsService.getOrCreateFlow(
        FLOW_NAMES.RECRUITMENT_SEARCH
      );
      AnalyticsService.dispatchEvent(eventNames.RECRUITMENT_SEARCH_DETAIL, {
        flow_id: recruitmentSearchFlow.flow_id,
        screen_presentation_id: recruitmentSearchFlow.screen_presentation_id,
        recruitment_search_id,
        recruitment_screen_name,
        search_detail_id,
        search_detail_name,
        search_detail_value,
        campaign_id,
      });
    },
    []
  );

  return useMemo(() => ({detail}), [detail]);
}

export default useTrackRecruitmentSearchDetail;
